export interface AudioQualityMetrics {
  effectiveSuppressionLevel?: number;
}

export interface INoiseProcessor {
  init(context: AudioContext): Promise<void>;
  process(stream: MediaStream): Promise<MediaStream>;
  stop(): void;
  setMuted(muted: boolean): Promise<void>;
  enableProcessing(enabled: boolean): Promise<void>;
  setSmartMixing(enabled: boolean): void;
  setDynamicSuppression?(enabled: boolean): void;
  setSuppressionLevel?(level: number): void;
  destroy(): void;

  // Event handlers
  onMetrics(callback: (metrics: Partial<AudioQualityMetrics>) => void): void;

  get node(): AudioWorkletNode | null;

  // Smart Mixing Controls (Optional - mainly for DeepFilter)
  setPreGainEnabled?(enabled: boolean): void;
  setEQEnabled?(enabled: boolean): void;
  setCompressorEnabled?(enabled: boolean): void;
  setGateEnabled?(enabled: boolean): void;
  setPostGainEnabled?(enabled: boolean): void;
  getSmartMixingOptions?(): {
    smartMixing: boolean;
    preGain: boolean;
    eq: boolean;
    compressor: boolean;
    gate: boolean;
    postGain: boolean;
  };
}

// 60 is the balanced default: Good suppression while preserving natural voice.
export const DEFAULT_SUPPRESSION_LEVEL = 60;
